export default __webpack_public_path__ + "static/media/iQuippo_Brochure.d789f5c9.pdf";